<script>
import {sync} from "vuex-pathify";

export default {
    props: {
        gifts: Object,
    },
    methods: {
        selectGift(giftId) {
            this.$store.set('form_data/gift', giftId);
        },
    },
    computed: {
        selectedGiftId: sync('form_data/gift'),
    }
}
</script>

<template>
    <div>
        <button
            v-for="(gift, giftId) in gifts"
            :key="giftId"
            @click="selectGift(giftId)"
            class="gift-choice__button"
            :class="{ 'selected': giftId === selectedGiftId }"
        >
            <span>{{ gift }}</span>
        </button>
    </div>
</template>
